import DataGrid from "./common/DataGrid";


const Cards = () => {
return (
    <div style={{ height: '80vh' }}>
<DataGrid
  columnDefs={[{ field: 'card_number' }, { field: 'card_expiry' },{field : 'card_amount'},{field : 'card_status'},{field : 'card_created_on'}]}
  apiEndpoint="https://oms-be.shreetradingcompany.in/api/get-allcards/"
  height="80vh"
/>
</div>
)
}

export default Cards;